/**
 * AI Coach Constants
 *
 * Step titles, descriptions, colors, and other constants for the AI Coach feature
 */

import type { AICoachPart } from '../../../../../../pure-js/types/AICoach'

// Translation keys for step titles (actual translations in language files)
export const STEP_TITLE_KEYS: Record<AICoachPart, string> = {
  0: 'aiCoach.steps.intro.title',
  1: 'aiCoach.steps.taskPerformance.title',
  2: 'aiCoach.steps.communication.title',
  3: 'aiCoach.steps.everydayWork.title'
}

// Translation keys for step descriptions
export const STEP_DESCRIPTION_KEYS: Record<AICoachPart, string> = {
  0: 'aiCoach.steps.intro.description',
  1: 'aiCoach.steps.taskPerformance.description',
  2: 'aiCoach.steps.communication.description',
  3: 'aiCoach.steps.everydayWork.description'
}

/**
 * UI Colors specific to AI Coach
 * These extend the design system colors for AI Coach specific elements
 */
export const AI_COACH_COLORS = {
  // Page background
  pageBackground: '#212629',

  // Card/panel backgrounds
  cardBackground: 'rgba(255, 255, 255, 0.05)',

  // Modal background
  modalBackground: '#2D3136'
} as const

/**
 * Common style constants
 */
export const AI_COACH_STYLES = {
  // Border radius values
  borderRadius: {
    small: 6,
    medium: 12,
    large: 16,
    pill: 999
  },

  // Spacing/padding values
  spacing: {
    xs: 1,
    sm: 1.5,
    md: 2,
    lg: 2.5,
    xl: 3
  },

  // Avatar sizes
  avatarSize: {
    sm: 32,
    md: 36,
    lg: 48
  }
} as const
